// Force responsive behavior even in desktop mode on mobile devices
export const forceResponsive = () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isTablet = /iPad/i.test(navigator.userAgent);
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  if (isMobile || isTablet || isTouchDevice) {
    // Force viewport meta tag
    let viewport = document.querySelector('meta[name=viewport]');
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.name = 'viewport';
      document.head.appendChild(viewport);
    }
    viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    
    // Add mobile class to body
    document.body.classList.add('force-mobile');
    
    // Force responsive CSS
    const style = document.createElement('style');
    style.id = 'force-responsive-style';
    style.textContent = `
      .force-mobile * {
        box-sizing: border-box !important;
      }
      
      .force-mobile {
        width: 100% !important;
        max-width: 100vw !important;
        overflow-x: hidden !important;
      }
      
      /* Home.css overrides */
      .force-mobile .section-3-text-content h3 {
        font-size: 24px !important;
        text-align: center !important;
        left: 0 !important;
        top: 0 !important;
      }
      
      .force-mobile .section-3-paragraphs {
        flex-direction: column !important;
        gap: 20px !important;
        text-align: center !important;
        left: 0 !important;
        top: 0 !important;
      }
      
      .force-mobile .section-3-text-content p {
        text-align: center !important;
        left: 0 !important;
        top: 0 !important;
        margin: 0 auto !important;
        max-width: 90% !important;
        letter-spacing: 1px !important;
      }
      
      .force-mobile .section-3-gallery-grid {
        flex-direction: column !important;
        gap: 15px !important;
        height: auto !important;
      }
      
      .force-mobile .section-3-gallery-item.premium-slide {
        height: 250px !important;
        width: 100% !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
      
      /* About.css overrides */
      .force-mobile .about-text-content h3 {
        font-size: 24px !important;
        text-align: center !important;
        left: 0 !important;
        top: 0 !important;
      }
      
      .force-mobile .about-paragraphs {
        flex-direction: column !important;
        gap: 20px !important;
        text-align: center !important;
        left: 0 !important;
        top: 0 !important;
      }
      
      .force-mobile .about-paragraphs p {
        left: 0 !important;
        top: 0 !important;
        text-align: center !important;
        margin: 0 auto !important;
        max-width: 90% !important;
        letter-spacing: 1px !important;
      }
      
      .force-mobile .about-image-grid {
        grid-template-columns: 1fr !important;
        grid-template-rows: auto auto auto !important;
        height: auto !important;
        gap: 15px !important;
      }
      
      .force-mobile .about-image-item {
        height: 250px !important;
        margin: 0 !important;
        transform: none !important;
      }
      
      .force-mobile .our-story-content h3 {
        font-size: 24px !important;
        text-align: center !important;
        left: 0 !important;
        top: 0 !important;
        position: static !important;
      }
      
      .force-mobile .our-story-paragraphs {
        flex-direction: column !important;
        gap: 20px !important;
        text-align: center !important;
        left: 0 !important;
        top: 0 !important;
      }
      
      .force-mobile .our-story-paragraphs p {
        text-align: center !important;
        margin: 0 auto !important;
        max-width: 90% !important;
        left: 0 !important;
        top: 0 !important;
      }
      
      @media (pointer: coarse) {
        .about-text-content h3,
        .section-3-text-content h3,
        .our-story-content h3 {
          text-align: center !important;
          left: 0 !important;
          top: 0 !important;
        }
        
        .about-paragraphs,
        .section-3-paragraphs,
        .our-story-paragraphs {
          flex-direction: column !important;
          gap: 20px !important;
          text-align: center !important;
          left: 0 !important;
          top: 0 !important;
        }
        
        .about-paragraphs p,
        .section-3-text-content p,
        .our-story-paragraphs p {
          text-align: center !important;
          left: 0 !important;
          top: 0 !important;
          margin: 0 auto !important;
        }
      }
    `;
    
    // Remove existing style if present
    const existingStyle = document.getElementById('force-responsive-style');
    if (existingStyle) {
      existingStyle.remove();
    }
    
    document.head.appendChild(style);
  }
};

// Detect orientation change
export const handleOrientationChange = () => {
  window.addEventListener('orientationchange', () => {
    setTimeout(() => {
      forceResponsive();
      // Force reflow
      document.body.style.display = 'none';
      // eslint-disable-next-line no-unused-expressions
      document.body.offsetHeight; // Force reflow
      document.body.style.display = '';
    }, 100);
  });
  
  // Also handle resize events
  window.addEventListener('resize', () => {
    setTimeout(() => {
      forceResponsive();
    }, 50);
  });
};

// Detect if user is trying to view desktop version on mobile
export const detectDesktopModeOnMobile = () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const viewportWidth = window.innerWidth;
  
  // If mobile device but viewport is wide (desktop mode)
  if (isMobile && viewportWidth > 1024) {
    forceResponsive();
    
    // Add additional styles for desktop mode on mobile
    const desktopModeStyle = document.createElement('style');
    desktopModeStyle.id = 'desktop-mode-mobile-fix';
    desktopModeStyle.textContent = `
      @media screen and (max-device-width: 768px) {
        .about-text-content h3,
        .section-3-text-content h3,
        .our-story-content h3 {
          font-size: 24px !important;
          text-align: center !important;
          left: 0 !important;
          top: 0 !important;
        }
        
        .about-paragraphs,
        .section-3-paragraphs,
        .our-story-paragraphs {
          flex-direction: column !important;
          gap: 20px !important;
          text-align: center !important;
          left: 0 !important;
          top: 0 !important;
        }
        
        .about-paragraphs p,
        .section-3-text-content p,
        .our-story-paragraphs p {
          text-align: center !important;
          left: 0 !important;
          top: 0 !important;
          margin: 0 auto !important;
          font-size: 14px !important;
          letter-spacing: 1px !important;
        }
        
        .about-image-grid {
          grid-template-columns: 1fr !important;
          grid-template-rows: auto auto auto !important;
          height: auto !important;
          gap: 15px !important;
        }
        
        .about-image-item {
          height: 250px !important;
          margin: 0 !important;
          transform: none !important;
        }
        
        .section-3-gallery-grid {
          flex-direction: column !important;
          gap: 15px !important;
          height: auto !important;
        }
        
        .section-3-gallery-item.premium-slide {
          height: 250px !important;
          width: 100% !important;
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
      }
    `;
    
    const existingDesktopStyle = document.getElementById('desktop-mode-mobile-fix');
    if (existingDesktopStyle) {
      existingDesktopStyle.remove();
    }
    
    document.head.appendChild(desktopModeStyle);
  }
};
